import React from "react";
import StodumatPage from "@components/Pages/StodumatPage/StodumatPage";

export default function Software() {
    return <StodumatPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
